 {
    document.addEventListener("DOMContentLoaded", function () {
      const container = document.querySelector(".LoopMarque");
      if (!container) return;
      const boxes = Array.from(container.querySelectorAll(".slider__item"));
      const CLONE_COUNT = 3;
      for (let i = 0; i < CLONE_COUNT; i++) {
        boxes.forEach((box) => {
          container.appendChild(box.cloneNode(true));
        });
      }
      const scrollDistance = container.scrollWidth / 2;
      const SPEED = 70;
      const duration = scrollDistance / SPEED;
      const animation = gsap.to(container, {
        x: -scrollDistance,
        duration: duration,
        ease: "linear",
        repeat: -1,
      });
      container.addEventListener("mouseenter", () => animation.pause());
      container.addEventListener("mouseleave", () => animation.resume());
    });
  }
{
  document.addEventListener("DOMContentLoaded", () => {
    const tabs = document.querySelectorAll(".bicycle_tabs ul li");
    const boxes = document.querySelectorAll(".bicycle__Box");
    if (tabs.length && boxes.length) {
      tabs[0].classList.add("IsActiveTabs");
      boxes[0].classList.add("IsActiveBox");
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        tabs.forEach((t) => t.classList.remove("IsActiveTabs"));
        boxes.forEach((b) => b.classList.remove("IsActiveBox"));
        tab.classList.add("IsActiveTabs");
        if (boxes[index]) {
          boxes[index].classList.add("IsActiveBox");
        }
      });
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", () => {
  const COLLAPSE_HEIGHT = 80; 
  document.querySelectorAll(".disx__collections").forEach((box) => {
    const fullHeight = box.scrollHeight;
    if (fullHeight <= COLLAPSE_HEIGHT) return;
    box.style.maxHeight = COLLAPSE_HEIGHT + "px";
    const btn = document.createElement("span");
    btn.className = "read-more-btn";
    btn.textContent = "Zie meer";
    box.after(btn);
    let isOpen = false;
    btn.addEventListener("click", () => {
      if (!isOpen) {
        box.style.maxHeight = fullHeight + "px";
        btn.textContent = "Zie minder";
      } else {
        box.style.maxHeight = COLLAPSE_HEIGHT + "px";
        btn.textContent = "Zie meer";
      }
      isOpen = !isOpen;
    });
  });
});
}
{

  document.addEventListener('DOMContentLoaded', () => {
    new Swiper(".relatedProduct-slider", {
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 1,
        },
      },
      
    });
  })
}



const openPopupBtn = document.getElementById("popup-product-open-btn");
const popup = document.getElementById("popup-product");
const closePopupBtn = document.getElementById("popup-product-close-btn");

openPopupBtn.onclick = function () {
  popup.style.display = "flex";
  popup.style.animation = "none";
  setTimeout(() => {
    popup.style.animation = "fadeIn 0.5s forwards";
  }, 10);
}

closePopupBtn.onclick = function () {
  popup.style.display = "none";
}

window.onclick = function (event) {
  if (event.target == popup) {
    popup.style.display = "none";
  }
}

{

  document.addEventListener('DOMContentLoaded', () => {
    new Swiper(".relatedProduct-slider", {
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 1,
        },
      },
      
    });
  })
}